import styled from "styled-components"

export const BreakoutRoomButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
`

export const BreakoutRoomButtonRoot = styled.div`
    color: #fff;
    cursor: pointer;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    padding: 8px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    border: 1px solid #666666;
    border-radius: 3px;
    height: 35px;
    min-width: 140px;
    :hover {
        background-color: #666666;
        border: 1px solid #666666;
    }
`
